import axios from 'axios'
import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Button, Col, Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { CarpetaDigitalComponent } from 'recupero-caso-general'
import BitacoraGestion from '../../bitacora-gestion-recuperador'

const AccionesLegalizacion = ({setActionButton, formik,porConvenioOld,miRecobroNo, periodo, idRGestion, mtoPago, nombreGirador,idGiradorD}) => {
  const [showCarpeta, setShowCarpeta] = useState(false)
  const queryState=JSON.parse(localStorage.getItem('filtrosRecuperoCias'));
  const [showBitacora, setShowBitacora] = useState(false)
  const handleShowCarpeta = () => setShowCarpeta(true)
  const handleCloseCarpeta= () => setShowCarpeta(false)
  const handleCloseBitacora = () => {setShowBitacora(false)}
  const handleShowBitacora = () => setShowBitacora(true)
  const history =useNavigate()
 
  const data_legalizacion =useSelector((state) => state.legalizacionPagoReducer)
  const {cfg_form10}=data_legalizacion
  const data_encargado_cia = useSelector((state) => state.encargado_compania)
  const {llaves} = data_encargado_cia


  return (
    <>
      <style type='text/css'>
        {`
    .btn-carpeta {
      background-color: #D59B49;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    } 
    .btn-carta {
      background-color:  #2E6EA5;
      color: #FFFFFF;
      width: 140px;     
      padding:6px 0px 6px 0px;
    }
    .btn-carta:hover{
        background-color:  #5b9ad1;
        color: #FFFFFF;
    }
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color: #d3807f;
      color: #FFFFFF;
    }
    .btn-legalizar {
      background-color: #01CECA;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-legalizar:hover{
        background-color: #66CCCC;
      color: #FFFFFF;
    }
    .btn-volver {
      
      color: #66CCCC;
      border: 1px solid #C00
     
      width: 140px;

    }
   

    .btn-tamano{
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    `}
      </style>
      <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">      
        
        <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
          idCaso={llaves && llaves['idCaso']}
          idImplicado={llaves && llaves['idImplicado']}
          idOrganizacionCaso={llaves && llaves['idOrgCaso']}
            prototipo={2}
            
          />     
     
    </Modal>
      <BitacoraGestion
        handleCloseBitacora={handleCloseBitacora}
        showBitacora={showBitacora}
      />
      <Row>
        <Col className='d-flex align-items-end justify-content-end m-2'>
          <Button className='m-2 w-auto' variant='outline-info' onClick={()=> history('/area-trabajo-recupero-companias',{state:{queryState}})} >
          {cfg_form10 && cfg_form10.cfg_form10["legalizarecobro-btn-volver"]}
          </Button>
          <Button className='m-2 ' variant='carpeta' onClick={handleShowCarpeta}>
          {cfg_form10 && cfg_form10.cfg_form10["legalizarecobro-btn-carpeta"]}
          </Button>
          <Button className='m-2' variant='bitacora' onClick={handleShowBitacora}>
          {cfg_form10 && cfg_form10.cfg_form10["legalizarecobro-btn-bitacora"]}
          </Button>
          {/*<Button
            className='m-2'
            variant='legalizar'
            type='onSubmit'
            onClick={()=>setActionButton("procesar")}
            //onSubmit={formik.handleSubmit}
            
            name='procesar'
          >
            {cfg_form10&& cfg_form10.cfg_form10["legalizarecobro-btn-procesarrspta"]}
          </Button>
          <Button
            className='m-2'
            variant='actualizar'
           // onClick={e=>handleVisar(e)}
           onClick={()=>setActionButton("visar")}
            type='onSubmit'
            //onSubmit={formik.handleSubmit}
           
            name='visar'
          >
            {cfg_form10&& cfg_form10.cfg_form10["legalizarecobro-btn-visar"]}
          </Button>*/}            
        </Col>
      </Row>
    </>
  )
}

export default AccionesLegalizacion
